import { contactContent } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
            韩漫推荐与合作
          </span>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">{contactContent.title}</h2>
          <p className="text-sm text-foreground-500 mb-2">{contactContent.subtitle}</p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-8">{contactContent.desc}</p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {contactContent.methods.map((m, i) => (
              <div key={i} className="p-5 rounded-lg bg-background-50 border border-background-200">
                <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 text-lg mb-3">
                  <i className={m.icon}></i>
                </div>
                <p className="text-xs text-foreground-500 mb-1">{m.label}</p>
                <p className="text-sm font-medium text-foreground-800">{m.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}